// src/components/xpUtils.js
export const XP_AMOUNTS = {
  PROFILE_PICTURE: 20,
  SKIN_QUIZ: 50,
  DAILY_CHECK_IN: 20,
  CURU_CHAT_POST: 50,
  PRODUCT_TAG: 5,
  PRODUCT_REVIEW: 30,
  PHOTO_REVIEW: 5
};

const getCurrentLevel = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return null;

    const response = await fetch('https://dev-api.curu.com.au/api/profile', {
      headers: { Authorization: `Bearer ${token}` },
    });
    
    if (!response.ok) return null;
    
    const data = await response.json();
    return data.level?.id || null;
  } catch (error) {
    console.error('Error fetching current level:', error);
    return null;
  }
};

export const trackXPEarned = async (amount, activityType = 'default') => {
  console.log(`Storing XP earned: ${amount} for activity: ${activityType}`);
  
  // Get the user's level before earning XP
  const levelBefore = await getCurrentLevel();
  
  const existingXP = localStorage.getItem('earnedXP');
  const totalXP = existingXP ? parseInt(existingXP) + amount : amount;
  
  // Store both XP amount and activity type
  localStorage.setItem('earnedXP', totalXP.toString());
  localStorage.setItem('xpActivityType', activityType);
  console.log(`Total XP stored: ${localStorage.getItem('earnedXP')}, Activity: ${activityType}`);
  
  setTimeout(async () => {
    const levelAfter = await getCurrentLevel();
    
    if (levelBefore && levelAfter && levelAfter > levelBefore) {
      console.log(`Level up detected! From ${levelBefore} to ${levelAfter}`);
      
      localStorage.setItem('levelUp', levelAfter.toString());
      
      window.dispatchEvent(new CustomEvent('check-level-up', { 
        detail: { 
          previousLevel: levelBefore, 
          newLevel: levelAfter 
        } 
      }));
    }
    
    if (levelAfter) {
      localStorage.setItem('userLevel', levelAfter.toString());
    }
  }, 1000); 
};

// daily check-in

// Daily check-in functions with better debugging
const getTodayDateString = () => {
  const today = new Date().toISOString().split('T')[0];
  console.log("📅 Today's date string:", today);
  return today;
};

const hasCheckedInToday = () => {
  const lastCheckIn = localStorage.getItem('lastDailyCheckIn');
  const today = getTodayDateString();
  
  console.log("🔍 Checking daily check-in status:");
  console.log("  - Last check-in date:", lastCheckIn);
  console.log("  - Today's date:", today);
  console.log("  - Has checked in today:", lastCheckIn === today);
  
  return lastCheckIn === today;
};

const markTodayAsCheckedIn = () => {
  const today = getTodayDateString();
  localStorage.setItem('lastDailyCheckIn', today);
  console.log("Marked today as checked in:", today);
};

export const checkDailyCheckIn = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    console.log("No token found - user not logged in");
    return false;
  }
  
  console.log("Starting daily check-in process...");
  
  if (hasCheckedInToday()) {
    console.log("⏭User has already checked in today - no XP awarded");
    return false;
  }
  
  console.log("First login today - awarding daily check-in XP!");
  markTodayAsCheckedIn();
  trackXPEarned(XP_AMOUNTS.DAILY_CHECK_IN, 'daily_checkin');
  return true;
};

export const resetDailyCheckInForTesting = () => {
  console.log('🧪 TESTING: Clearing daily check-in flag');
  localStorage.removeItem('lastDailyCheckIn');
  console.log('🧪 You can now test daily check-in again');
};

if (typeof window !== 'undefined') {
  // ... your existing window commands
  window.resetDailyCheckIn = resetDailyCheckInForTesting;
  
  // Add a function to check the current status
  window.checkDailyStatus = () => {
    const lastCheckIn = localStorage.getItem('lastDailyCheckIn');
    const today = new Date().toISOString().split('T')[0];
    console.log('Current daily check-in status:');
    console.log('Last check-in:', lastCheckIn);
    console.log('Today:', today);
    console.log('Has checked in today:', lastCheckIn === today);
  };
}

// Profile Picture XP tracking
export const trackProfilePictureUpload = async () => {
  console.log("Checking profile picture upload XP...");
  
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      console.log("No token found - user not logged in");
      return false;
    }

    // Get user profile to check if they have a profile picture
    const response = await fetch('https://dev-api.curu.com.au/api/profile', {
      headers: { Authorization: `Bearer ${token}` },
    });
    
    if (!response.ok) {
      console.log("Failed to fetch profile data");
      return false;
    }
    
    const profileData = await response.json();
    const userId = profileData.id;
    
    // Check if we've already awarded XP for profile picture
    const hasShownProfilePicXP = localStorage.getItem(`profilePicXPShown_${userId}`);
    
    if (hasShownProfilePicXP) {
      console.log("Profile picture XP already awarded for this user");
      return false;
    }
    
    // Check if user now has a profile picture
    const hasProfilePicture = profileData.profile_picture && profileData.profile_picture.trim() !== '';
    
    if (hasProfilePicture) {
      console.log("✅ Profile picture uploaded - awarding XP!");
      trackXPEarned(XP_AMOUNTS.PROFILE_PICTURE, 'profile_picture');
      localStorage.setItem(`profilePicXPShown_${userId}`, 'true');
      
      // Dispatch event to trigger XP popup
      setTimeout(() => {
        console.log("🚀 Dispatching check-xp-earned event for profile picture");
        window.dispatchEvent(new CustomEvent('check-xp-earned'));
      }, 500);
      
      return true;
    } else {
      console.log("No profile picture found yet");
      return false;
    }
    
  } catch (error) {
    console.error('Error checking profile picture XP:', error);
    return false;
  }
};

//tracking functions with activity types
export const trackCuruChatPost = () => {
  console.log("Tracking XP for creating a Curu Chat post");
  trackXPEarned(XP_AMOUNTS.CURU_CHAT_POST, 'curu_chat_post');
};

export const trackProductTag = () => {
  console.log("Tracking XP for tagging a product");
  trackXPEarned(XP_AMOUNTS.PRODUCT_TAG, 'product_tag');
};

export const trackProductReview = () => {
  console.log("Tracking XP for writing a product review");
  trackXPEarned(XP_AMOUNTS.PRODUCT_REVIEW, 'product_review');
};

export const trackPhotoReview = () => {
  console.log("Tracking XP for adding photos to a review");
  trackXPEarned(XP_AMOUNTS.PHOTO_REVIEW, 'photo_review');
};

export const trackProfilePicture = () => {
  console.log("Tracking XP for adding profile picture");
  trackXPEarned(XP_AMOUNTS.PROFILE_PICTURE, 'profile_picture');
};

export const trackSkinQuiz = () => {
  console.log("Tracking XP for completing skin quiz");
  trackXPEarned(XP_AMOUNTS.SKIN_QUIZ, 'skin_quiz');
};

//testing functions
export const testXPPopup = (amount = 50, activityType = 'daily_checkin') => {
  console.log(`🧪 Testing XP popup with ${amount}XP for ${activityType}`);
  localStorage.setItem('earnedXP', amount.toString());
  localStorage.setItem('xpActivityType', activityType);
  window.dispatchEvent(new CustomEvent('check-xp-earned'));
};

export const testProfilePictureXP = () => {
  console.log('🧪 Testing profile picture XP popup');
  localStorage.setItem('earnedXP', '20');
  localStorage.setItem('xpActivityType', 'profile_picture');
  window.dispatchEvent(new CustomEvent('check-xp-earned'));
};

export const testLevelPopup = (level = 3) => {
  console.log(`🧪 Testing Level popup with Level ${level}`);
  localStorage.setItem('levelUp', level.toString());
  window.dispatchEvent(new CustomEvent('check-level-up'));
};

export const testBothPopups = (xpAmount = 100, level = 4, activityType = 'product_review') => {
  console.log(`🧪 Testing both popups: ${xpAmount}XP then Level ${level}`);
  
  localStorage.setItem('earnedXP', xpAmount.toString());
  localStorage.setItem('xpActivityType', activityType);
  window.dispatchEvent(new CustomEvent('check-xp-earned'));
  
  localStorage.setItem('levelUp', level.toString());
};

export const testDailyCheckIn = () => {
  console.log('🧪 Testing daily check-in (clearing previous check-in)');
  localStorage.removeItem('lastDailyCheckIn');
  return checkDailyCheckIn();
};

export const clearTestData = () => {
  console.log('🧹 Clearing test data');
  localStorage.removeItem('earnedXP');
  localStorage.removeItem('xpActivityType');
  localStorage.removeItem('levelUp');
  localStorage.removeItem('userLevel');
  localStorage.removeItem('lastDailyCheckIn');
  // Clear profile picture XP flags
  const keys = Object.keys(localStorage);
  keys.forEach(key => {
    if (key.startsWith('profilePicXPShown_')) {
      localStorage.removeItem(key);
    }
  });
};

// Quick browser console commands for testing
if (typeof window !== 'undefined') {
  window.testXP = testXPPopup;
  window.testLevel = testLevelPopup;
  window.testBoth = testBothPopups;
  window.testDailyCheckIn = testDailyCheckIn;
  window.testProfilePicXP = testProfilePictureXP;
  window.clearXPTests = clearTestData;
}